"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpResponseStatusCodes = void 0;
var HttpResponseStatusCodes;
(function (HttpResponseStatusCodes) {
    HttpResponseStatusCodes[HttpResponseStatusCodes["OK"] = 200] = "OK";
    HttpResponseStatusCodes[HttpResponseStatusCodes["Created"] = 201] = "Created";
    HttpResponseStatusCodes[HttpResponseStatusCodes["NoContent"] = 204] = "NoContent";
    HttpResponseStatusCodes[HttpResponseStatusCodes["PartialContent"] = 206] = "PartialContent";
    HttpResponseStatusCodes[HttpResponseStatusCodes["MultiStatus"] = 207] = "MultiStatus";
    HttpResponseStatusCodes[HttpResponseStatusCodes["BadRequest"] = 400] = "BadRequest";
    HttpResponseStatusCodes[HttpResponseStatusCodes["Unauthorized"] = 401] = "Unauthorized";
    HttpResponseStatusCodes[HttpResponseStatusCodes["Forbidden"] = 403] = "Forbidden";
    HttpResponseStatusCodes[HttpResponseStatusCodes["NotFound"] = 404] = "NotFound";
    HttpResponseStatusCodes[HttpResponseStatusCodes["UnprocessableEntity"] = 422] = "UnprocessableEntity";
    HttpResponseStatusCodes[HttpResponseStatusCodes["ServerError"] = 500] = "ServerError";
    HttpResponseStatusCodes[HttpResponseStatusCodes["NotImplemented"] = 501] = "NotImplemented";
    HttpResponseStatusCodes[HttpResponseStatusCodes["BadGateway"] = 502] = "BadGateway";
    HttpResponseStatusCodes[HttpResponseStatusCodes["ServiceUnavailable"] = 503] = "ServiceUnavailable";
    HttpResponseStatusCodes[HttpResponseStatusCodes["GatewayTimeout"] = 504] = "GatewayTimeout";
})(HttpResponseStatusCodes = exports.HttpResponseStatusCodes || (exports.HttpResponseStatusCodes = {}));
exports.default = HttpResponseStatusCodes;
